import { inject, Injectable } from '@angular/core';
import { IStepOption, TourService } from 'ngx-ui-tour-primeng';
import { DELAY_AFTER_NAVIGATION } from '../shared/tour-helpers';
import { Router } from '@angular/router';
import { ProfileService } from './profile.service';
import { take } from 'rxjs/internal/operators/take';

@Injectable({
  providedIn: 'root',
})
export class AppTourService {
  private delayAfterNavigation = inject(DELAY_AFTER_NAVIGATION);
  private tourService: TourService = inject(TourService);
  private profileService = inject(ProfileService);
  private userSlugName: string | null = null;
  public activePageKey: string | null = null;
  private tourEnabled = false;

  private tourFlags = {
    completed: false,
    exited: false,
    skipped: false,
  };

  private profileLoaded = false;

  public allToursCompleted = false;

  private requiredPageKeys: string[] = [
    'expense-list',
    'payment-list',
    'profile-profit',
    'marketplace-reservation',
    'marketplace-reservation-details',
    'my-booking-reservation',
    'inventory-and-stock',
    'employee-list',
    'property-list',
    'property-add',
    'property-edit',
    'vat-list',
  ];

  constructor() {
    this.profileService.userDetails$.subscribe((data) => {
      if (data?.data?.userTypeId?.slug_name) {
        this.userSlugName = data.data.userTypeId.slug_name;
      }
      // if (data?.data?.tourStatus) {
      //   this.tourFlags = data.data.tourStatus;
      //   this.checkAllToursCompleted();
      // }
      if (data?.data) {
        this.tourFlags = {
          completed: !!data.data.tour_completed,
          exited: !!data.data.tour_exited,
          skipped: !!data.data.tour_skipped,
        };
      }
      this.checkAllToursCompleted();
      this.profileLoaded = true;
    });
  }

  startTour(
    steps: IStepOption[],
    route: string,
    pageKey: string,
    allowedSlug: string = 'marketplace'
  ): void {
    if (!this.tourEnabled) return; // stop running tours
    if (!this.profileLoaded) return;

    const flags = this.tourFlags;

    if (flags.completed || flags.exited || flags.skipped) return;
    if (this.userSlugName !== allowedSlug) return;

    this.activePageKey = pageKey;
    this.tourService.end();
    this.tourService.initialize(steps, {
      route,
      delayAfterNavigation: this.delayAfterNavigation,
    });
    this.tourService.start();

    this.tourService.end$.pipe(take(1)).subscribe(() => {
      if (!this.tourFlags.skipped && !this.tourFlags.exited) {
        this.tourFlags.completed = true;
        this.checkAllToursCompleted();
        this.profileService
          .tourGuideUpdate({ tour_completed: true })
          .subscribe();
      }
    });
  }
  stopTour() {
    this.tourService.end();
  }
  exitTour(): void {
    if (!this.activePageKey) return;

    this.tourFlags.exited = true;
    this.profileService.tourGuideUpdate({ tour_exited: true }).subscribe();

    this.tourService.end();
  }

  skipTour(): void {
    if (!this.activePageKey) return;

    this.tourFlags.skipped = true;
    this.profileService.tourGuideUpdate({ tour_skipped: true }).subscribe();

    this.tourService.end();
  }

  resetSkippedTours(): void {
    if (this.tourFlags.skipped) {
      this.tourFlags.skipped = false;
    }
    this.checkAllToursCompleted();
  }

  private checkAllToursCompleted(): void {
    this.allToursCompleted = this.tourFlags.completed;
    // console.log('All tours completed:', this.allToursCompleted);
  }
}
